import React, { useState, useEffect, useRef } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import * as videos from '../shared/video-list';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { Col, Form, Row } from 'react-bootstrap';
import { Password } from "primereact/password";



export default function SidaExtenssion(props) {
    const toast = useRef(null);
    const [showVideo, setShowVideo] = useState(false);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [padTop, setPadTop] = useState(40);
   

    useEffect(() => {
      if(props.top != 10) setPadTop(5);
    }, []);

    return(      
      <>
        <h3></h3>
        <div style={{padding:"15px", borderTopLeftRadius:"10px", borderTopRightRadius:"10px", backgroundColor:"rgb(251, 251, 200)", textAlign:"center", fontSize:"18pt"}}>
          افزونه سیدا          
        </div>
        <div style={{padding:"15px", backgroundColor:"rgba(244, 252, 238, 1)", textAlign:"right", fontSize:"14pt"}}>
          با کمک افزونه سیدا می توانید به راحتی اطلاعات زیر را به کلاسیکو7 منتقل نمائید
          <div style={{marginTop:"5px", fontSize:"16pt", color:"#3d3db6ff"}}>
            <i class="bi bi-star-fill" style={{color:"#0f811eff", fontSize:"18pt"}}></i>&nbsp;انتقال لیست دانش آموزان
          </div>
          <div style={{marginTop:"5px", fontSize:"16pt", color:"#3d3db6ff"}}>
            <i class="bi bi-star-fill" style={{color:"#0f811eff", fontSize:"18pt"}}></i>&nbsp;انتقال لیست دبیران
          </div>
          <div style={{marginTop:"5px", fontSize:"16pt", color:"#3d3db6ff"}}>
            <i class="bi bi-star-fill" style={{color:"#0f811eff", fontSize:"18pt"}}></i>&nbsp;انتقال لیست کلاس ها
          </div>
          <div style={{marginTop:"5px", fontSize:"16pt", color:"#3d3db6ff"}}>
            <i class="bi bi-star-fill" style={{color:"#0f811eff", fontSize:"18pt"}}></i>&nbsp;انتقال کلاس بندی دانش آموزان
          </div>
          <div style={{marginTop:"35px", fontSize:"12pt", color:"#000000"}}>
            این افزونه در مرورگر <span style={{color:"#f00"}}>کروم</span> قابل نصب است. پس از نصب این افزونه وارد سیدا شوید. سپس وارد صفحه مورد نظر شوید. آنگاه افزونه را اجرا نموده و دکمه ارسال اطلاعات را کلیک نمائید.
            به همین سادگی اطلاعات به کلاسیکو 7 منتقل می شود.
          </div>
          <div style={{marginTop:"35px", fontSize:"12pt", color:"#000000"}}>
            جهت حفظ امنیت داده ها باید رمز استفاده از افزونه را از همین سامانه(کلاسیکو7) و از طریق لینک زیر دریافت نمائید
          </div>
          <div style={{marginTop:"5px", marginBottom:"50px", fontSize:"16pt", color:"#000000"}}>
            <a href='/school/sida/token/get' style={{textDecoration:"none"}} target='_blank' >دریافت رمز</a>
          </div>
          <div style={{marginTop:"35px", marginBottom:"50px", fontSize:"16pt", color:"#000000"}}>
            <a href='https://chromewebstore.google.com/detail/edlnghlhhmmpbipilaaniieagjfbhhmb?utm_source=item-share-cb' style={{textDecoration:"none"}} target='_blank' >نصب افزونه</a>
          </div>
        </div>
      </>  
    );
  
}
